<template>
   <v-row>
        <v-col cols="12">
          <v-card outlined min-height="300px" class="pa-5">
            <v-col cols="12" align-center justify-center>
              <v-row no-gutters>
                <v-col cols="12">
                  <v-row no-gutters class="align-center justify-center">
                    <v-col cols="11">
                      <h2>About</h2>
                      <p>Personaminer is a research tool built to learn the expression of personality traits in tweets and make predictions about these traits by analyzing the linguistic features and behavioral attributes. The tool has been built by Ahmet Emre Aladag, a PhD Candidate in Boğaziçi University, Istanbul, Turkey. The ethical consent has been given to pursue this research.</p>

                      <p>When you approve the consent by logging in via Twitter, your tweets are downloaded for analysis. Machine Learning algorithms are applied on the tweets to predict your personality trait scores. You will then be asked to fill out a personality test and demographics information. You are then displayed your estimated personality trait scores and the actual results calculated from your test responses.</p>

                      <p>Your authenticity score will be calculated by comparing the estimated and actual scores and displayed with the results. The higher the score is, the more you represent your personality in your tweets according to our calculation. The score has no scientific basis but is provided for entertainment purposes.</p>
                      <h2>FAQ</h2>
                      <p><strong>Do you sell any personal data to third parties (including companies, advertisers, political parties etc.)?</strong></p>

<p>No, and we won’t ever do that.</p>

                      <p><strong>Why do you require Twitter login?</strong></p>

<p>Our research objective is to correlate Twitter usage with your personality trait scores, and we need to access your Twitter activity. That’s why we require Twitter login.</p>

<p><strong>Will my Twitter account be compromised if I login with Twitter?</strong></p>

<p>No, this is a read-only process. We don’t have access to your Twitter password. We only ask for permission in order to read your Tweets and profile bio.</p>

                    </v-col>
                  </v-row>
                </v-col>
              </v-row>
            </v-col>
          </v-card>
        </v-col>
   </v-row>
</template>

<script>
export default {
  name: 'About'
}
</script>

<style scoped>

</style>
